<template>
  <div class="get-click" style="position: absolute; bottom:45px; width: 100%; display:flex; align-items: center; justify-content: center;">
    <v-btn
      class="back-button"
      v-on:click='clicked'
      elevation="3"
      color="primary"
      depressed
      raised
    >
      {{ $t('Back') }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'back-button',
  props: ['toggled'],
  methods: {
    clicked: function () {
      window.location.href = this.getBaseUrl()
    }
  }
}
</script>

<style>
.v-application #stel .primary {
  font-family: Helvetica, sans-serif;
  font-weight: 400;
  background-color: #085a99 !important;
  border-color: #085a99 !important;
}
</style>
